/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.blog-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.contact-btn' ).each( function() {
        $( this ).prepend( '<span class="icon-wrapper"><svg class="icon icon-contact"><use xlink:href="#icon-contact"></use></svg></span>' );
      } );

      $( '.telephone-btn' ).each( function() {
        $( this ).prepend( '<span class="icon-wrapper"><svg class="icon icon-phone"><use xlink:href="#icon-phone"></use></svg></span>' );
      } );


      const alertBannerEl = document.getElementById( 'alert-banner' );
      let alertCookieSlug = '';
      if ( alertBannerEl ) {
        alertCookieSlug = 'alert_' + $( '.js-close-alert' ).attr( 'data-slug' ) + '_dismissed';

        if ( !sessionStorage.getItem( alertCookieSlug, 'true' ) ) {
          $( alertBannerEl ).show();
          $( 'body' ).addClass( 'js-show-alert-banner' );
        }

        $( alertBannerEl ).find( '.js-close-alert' ).click( function() {
          $( alertBannerEl ).hide();
          sessionStorage.setItem( alertCookieSlug, 'true' );
          $( 'body' ).removeClass( 'js-show-alert-banner' ).addClass( 'js-hide-alert-banner' );
        } );
      }


      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }

        const viewportWidth = $( window ).width();
        if ( viewportWidth < 769 ) {
          $( '.dropdown-toggle' ).on( 'toggleAfter', ( event ) => {
            $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
          } );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
